import Store from "../../stateStore";
import { Alert } from "antd";

export default function PlatformPageText() {
  const stateStore = Store.useStore();
  const org = stateStore.get("organization");

  return <Alert type="success" message={org?.platformPageText}></Alert>;
}
